import * as Redux from "redux";
import { routerReducer } from "react-router-redux";
// Domain models
import { appReducer } from "app/reducer";
import { externalReducer } from "external/reducer";
import { officeProductsReducer } from "products/reducer";
import { UserReducer } from "user/user/reducer";
// Reports
import { reportsReducer } from "reducers/reportsReducer";
// Authentication
import { authenticationFormsReducer } from "user/authentication/reducer";
//-------------------------------------------------------------------------------------------------------------------------------
// Root Reducer
//-------------------------------------------------------------------------------------------------------------------------------
export const rootReducer = Redux.combineReducers({
    routing: routerReducer,
    //-- Application
    app: appReducer,
    //-- External
    external: externalReducer,
    //-- Widgets
    products: officeProductsReducer,
    //-- Reports
    reports: reportsReducer,
    //-- User
    user: UserReducer,
    //-- Authentication Forms
    authenticationForms: authenticationFormsReducer
});
